import React from "react";
import { Award, Globe2, ShieldCheck } from "lucide-react";

export default function CertificationCard() {
  return (
    <section
      className="relative py-24 sm:py-32 bg-[#0A0A0A] border-b border-white/10"
      data-testid="certification-card"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-yellow-400 mb-4">
            <Award className="w-3.5 h-3.5" />
            Certificação Oficial
          </div>
          <h2 className="font-display text-5xl sm:text-6xl leading-[0.9] text-white">
            CARTÃO <br />
            <span className="text-yellow-400">MANOBRADOR</span>
            <br />
            DE GRUA TORRE.
          </h2>
          <p className="mt-6 text-zinc-400 text-lg leading-relaxed max-w-md">
            O teu cartão Manobrador. <span className="text-white font-semibold">Certificação CFOMP/SIGO</span>.
            Reconhecido em Portugal e na União Europeia.
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-md">
            <div className="flex items-center gap-3 p-4 border border-white/10 bg-zinc-900/50">
              <ShieldCheck className="w-5 h-5 text-yellow-400 shrink-0" />
              <span className="text-sm text-zinc-200">Reconhecido PT</span>
            </div>
            <div className="flex items-center gap-3 p-4 border border-white/10 bg-zinc-900/50">
              <Globe2 className="w-5 h-5 text-yellow-400 shrink-0" />
              <span className="text-sm text-zinc-200">Válido na UE</span>
            </div>
          </div>
        </div>

        {/* Real certification card images — frente + verso */}
        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
            <CardFace
              src="https://customer-assets.emergentagent.com/job_tower-crane-pro/artifacts/4adgatr4_1.png"
              alt="Cartão Manobrador CFOMP/SIGO — frente"
              label="Frente"
            />
            <CardFace
              src="https://customer-assets.emergentagent.com/job_tower-crane-pro/artifacts/jbvk41vt_2.png"
              alt="Cartão Manobrador CFOMP/SIGO — verso"
              label="Verso"
            />
          </div>
          <p className="mt-5 text-center text-xs uppercase tracking-widest text-zinc-500">
            Cartão real emitido · Frente e verso
          </p>
        </div>
      </div>
    </section>
  );
}

function CardFace({ src, alt, label }) {
  return (
    <div className="relative group" data-testid={`cert-card-${label.toLowerCase()}`}>
      <div
        aria-hidden="true"
        className="absolute -inset-3 bg-yellow-400/10 blur-2xl opacity-50 group-hover:opacity-100 transition-opacity"
      />
      <div className="relative border border-yellow-400/30 bg-black p-2 shadow-[0_20px_60px_-20px_rgba(253,224,71,0.35)] overflow-hidden">
        <img
          src={src}
          alt={alt}
          className="w-full h-auto block transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 bg-yellow-400 text-black px-2 py-0.5 text-[10px] uppercase tracking-widest font-bold">
          {label}
        </div>
      </div>
    </div>
  );
}
